module.exports = __webpack_public_path__ + "static/media/akash.6af4eb01.svg";